import { showModal } from "@/redux/message/messageSlice";
import type { AppDispatch } from "@/redux/store";
import { setPostLoginRedirect } from "@/redux/user/userSlice";
import { safeGetItem } from "@/utils/safeStorage";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router";

import { decideLoginParam } from "./loginParam";

/** Opens the login modal when the URL carries `?login=`, then strips the params. */
export const useLoginParam = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [searchParams, setSearchParams] = useSearchParams();
  // Once per arrival: stripping the params re-runs this effect.
  const handled = useRef(false);

  useEffect(() => {
    const loginParam = searchParams.get("login");
    if (loginParam === null) {
      handled.current = false;
      return;
    }
    if (handled.current) return;
    handled.current = true;

    const decision = decideLoginParam(
      loginParam,
      searchParams.get("next"),
      !!safeGetItem("access_token"),
    );

    const stripped = new URLSearchParams(searchParams);
    stripped.delete("login");
    stripped.delete("next");
    setSearchParams(stripped, { replace: true });

    if (!decision.open) return;
    if (decision.redirectTo) {
      dispatch(setPostLoginRedirect(decision.redirectTo));
    }
    dispatch(
      showModal({
        modalType: "login",
        ...(decision.reason && { data: { reason: decision.reason } }),
      }),
    );
  }, [dispatch, searchParams, setSearchParams]);
};
